import { type ReactNode } from "react";
import { useLocation } from "react-router-dom";

type RouteTransitionVariant = "default" | "planner";

export function RouteTransition({
  children,
  variant = "default",
}: {
  children: ReactNode;
  variant?: RouteTransitionVariant;
}) {
  const { pathname } = useLocation();
  const className =
    variant === "planner" ? "route-transition route-transition--planner" : "route-transition";

  return (
    <div key={pathname} className={className}>
      {children}
    </div>
  );
}
